export default __webpack_public_path__ + "static/B0132-8ba277b8ec6cf063207afe199c922ea0.png";